import { setupWorker } from 'msw/browser'
import { handlers } from 'prove-common/mocks'

export const worker = setupWorker(...handlers)
